import script from "./machine.vue?vue&type=script&setup=true&lang=ts"
export * from "./machine.vue?vue&type=script&setup=true&lang=ts"

import "./machine.vue?vue&type=style&index=0&id=02f09cbb&scoped=true&lang=stylus"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_8f6e2ea806ee27baec234857288b09f4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02f09cbb"]])

export default __exports__